import { format, isValid, parseISO } from 'date-fns';

/**
 * Format a yyyy-mm-dd (or ISO timestamp) string from the database. Goes through
 * parseISO rather than `new Date(str)`: a bare date string parses as UTC
 * midnight, and formatting that in a timezone behind UTC shows the day before.
 */
export const formatDbDate = (value: string | null | undefined, pattern = 'd MMM yyyy'): string => {
  if (!value) return '—';
  const d = parseISO(value);
  return isValid(d) ? format(d, pattern) : '—';
};
